import * as ko from 'knockout'
import { Page } from './pages/page'
import type { EventItem } from '@tixa/schema'
import { FeatureToggle } from '@tixa/schema'

import { EventState } from './store/event'
import { pageState } from './store/page'

import { observable } from 'knockout-decorators'

const MOBILE_BREAKPOINT = 1000

import './components/event-box/event-box'
import './components/event-gallery/event-gallery'
import './components/subpage-header/subpage-header'
import './components/age-restriction/age-restriction'

import './components/list-event/list-event'
import './components/page-sidebar/page-sidebar'

import './event.less'
import './components/event-box/offer-list.less'
import './components/event-box/ticket-type.less'

export class EventPage extends Page {
  @observable public hasCartLoaded = false

  @observable public event: EventItem | null = null
  @observable public pageTitle = ''
  public cover = ''
  @observable public isMultiEvent = false
  @observable public hasNoContent = true
  @observable public hasCompactIntro = false
  @observable public locationAddress = ''
  @observable public locationOpening = ''

  @observable public hasImageGallery = false

  @observable public gMapsSrc = ''

  private readonly isGmapsDisabled =
    import.meta.env.VITE_DISABLE_GMAPS === 'true'
  private readonly mapApiKey = this.isGmapsDisabled
    ? ''
    : import.meta.env.VITE_GMAPS_API_KEY
  private eventState = EventState.get()

  @observable private isMobile = window.innerWidth < MOBILE_BREAKPOINT

  constructor() {
    super()
    this.showBackToTopButton = ko.computed(() => !this.isMobile)
    this.updateIsMobile()
    window.addEventListener('resize', () => this.updateIsMobile())
    window.addEventListener('load', () => {
      setTimeout(async () => {
        await import('./components/cart/cart')
        this.hasCartLoaded = true
      }, 1000)
    })
    this.init()
  }

  private updateIsMobile() {
    this.isMobile = window.innerWidth < MOBILE_BREAKPOINT
  }

  public async init() {
    this.event = this.eventState.event
    if (!this.event) {
      return
    }

    // Location
    this.locationAddress = `${this.event.location.address.postalCode} ${this.event.location.address.addressLocality}, ${this.event.location.address.streetAddress}`
    // this.locationOpening = fecha.format(new Date(value.startDate), "HH:mm");
    this.locationOpening = this.event.customDate
      ? this.event.customDate
      : this.event.startDate

    // Gallery
    this.hasImageGallery = this.event.image.length > 1
    this.cover = this.event.image[0]

    this.isMultiEvent = this.eventState.isMultiEvent
    this.hasNoContent = !this.eventState.eventConfigs.hasContent

    const eventCopyRoot = document.querySelector(
      '#app > content.intro .textContent .content'
    )
    this.hasCompactIntro = !eventCopyRoot?.innerHTML.trim()

    this.pageTitle = this.isMultiEvent
      ? pageState.config.title
      : this.event.name

    const locationQuery = this.event.location.hasMap
      ? this.event.location.hasMap
      : `${this.event.location.name} ${this.locationAddress}`

    this.gMapsSrc = pageState.hasToggle(FeatureToggle.DisableGoogleMaps)
      ? ''
      : `https://www.google.com/maps/embed/v1/place?key=${
          this.mapApiKey
        }&q=${encodeURIComponent(locationQuery)}`
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const home = new EventPage()
